export const isIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  (navigator as unknown as { standalone?: boolean }).standalone === true;

/** Instagram/Facebook/Line webviews block Google OAuth (`disallowed_useragent`). */
export function isInAppBrowser(userAgent = navigator.userAgent): boolean {
  return /FBAN|FBAV|Instagram|Line\/|; wv\)|Snapchat|Twitter/i.test(userAgent);
}
